import * as React from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import { AXIOS_API_INSTANCE, LONG_DAY_FORMAT } from "../../../Constants"
import { send_authorized_request } from "../../../Constants/cognito"
import { useSnackbar } from 'notistack';
import { Box, Collapse, IconButton, useMediaQuery, useTheme } from "@mui/material"
import Grid from "@mui/material/Grid2"
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { CircularProgress } from '@mui/material';
import { serviceOrderChip } from "../../../Utils/service"
import { useTrackedUser } from "../../UserState"
import dayjs from "dayjs"
import { useNavigate } from "react-router-dom"
import { ExpandMore } from "../../../Utils/ExpandMore"


export default function CustomerItemHistoryModal({
    customerItem,
    open,
    closeModal
}) {
    const [my_user,] = useTrackedUser();
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    const [serviceOrders, setServiceOrders] = React.useState(undefined)
    const [loadingServiceOrders, setLoadingServiceOrders] = React.useState(false)
    const [expandedMap, setExpandedMap] = React.useState({});
    const isXsDown = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();

    React.useEffect(() => {
        if (open) {
            getServiceOrders()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    const getServiceOrders = () => {
        setLoadingServiceOrders(true)
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.get("serviceorders", {
                params: {
                    order_by: 'date_created',
                    order_by_direction: 'desc',
                    filters: JSON.stringify({ 'customer_item_id.eq': customerItem?.id }),
                },
            }).then((serviceOrders) => {
                setServiceOrders(serviceOrders.data.data)
                setLoadingServiceOrders(false)
            }
            ).catch((error) => {
                console.log(error);
                enqueueSnackbar(`Failed to get service history: ${error?.response ?? "Unknown Error Occurred"}`, { variant: 'error' })
                setLoadingServiceOrders(false)
            })
        )
    }

    return (
        (<div>
            <Dialog
                open={open}
                onClose={() => closeModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                maxWidth='md'
                fullWidth
            >
                <DialogTitle>
                    <span style={{ "paddingRight": "24px" }}>Service History</span>
                    <IconButton
                        aria-label="close"
                        onClick={() => closeModal(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    {loadingServiceOrders &&
                        <CircularProgress style={{ display: 'block', margin: '20% auto' }} color="inherit" />
                    }
                    {!loadingServiceOrders && serviceOrders?.length === 0 &&
                        <h3>No Service History</h3>
                    }
                    {!loadingServiceOrders && serviceOrders?.length > 0 &&
                        <Grid container direction={'column'} spacing={1}>
                            {serviceOrders.map((serviceOrder) =>
                                // TODO: Make this look good
                                <Grid container justifyContent={'space-between'} spacing={1} key={serviceOrder.id}>
                                    <Grid size="auto">
                                        <ExpandMore
                                            expand={expandedMap[serviceOrder.id] ?? false}
                                            onClick={() => setExpandedMap({ ...expandedMap, [serviceOrder.id]: !(expandedMap[serviceOrder.id] ?? false) })}
                                            aria-expanded={expandedMap[serviceOrder.id] ?? false}
                                            aria-label="show more"
                                        >
                                            <ExpandMoreIcon />
                                        </ExpandMore>
                                        {serviceOrderChip(my_user, serviceOrder.status_name, serviceOrder.status_type)}
                                    </Grid>
                                    {!isXsDown && <Grid size="auto">
                                        <span>{dayjs.utc(serviceOrder.date_created).local().format(LONG_DAY_FORMAT)} - {serviceOrder.closed_time ? dayjs.utc(serviceOrder.closed_time).local().format(LONG_DAY_FORMAT) : ''}</span>
                                    </Grid>}
                                    <Grid size="auto">
                                        <Button variant="outlined" onClick={() => { closeModal(true); navigate(`/ServiceOrders/${serviceOrder.id}`) }}>View</Button>
                                    </Grid>
                                    <Grid size={12}>
                                        <Collapse in={expandedMap[serviceOrder.id] ?? false} timeout="auto" unmountOnExit>
                                            <Box sx={{ fontSize: '14px' }}>
                                                <span><b>Dropoff Notes:</b></span>
                                                <br />
                                                <span>{serviceOrder.customer_notes}</span>
                                                {serviceOrder.summary_notes &&
                                                    <Box>
                                                        <span><b>Summary:</b></span>
                                                        <br />
                                                        <span>{serviceOrder.summary_notes}</span>
                                                    </Box>
                                                }
                                            </Box>
                                        </Collapse>
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>
                    }
                </DialogContent>
            </Dialog>
        </div>)
    );
}
